import { instance } from "libs/api";

import {
  EmailNotificationRecipient,
  GetEmailRecipientsParams
} from "../../emailNotifications.types";
import { ApiRoutesEmailNotifications } from "../../constants";

export const requestGetEmailRecipients = async (
  params: GetEmailRecipientsParams
): Promise<EmailNotificationRecipient[]> => {
  return await instance.get(ApiRoutesEmailNotifications.Recipients, { params });
};
